import { SentinelCacheObject } from './types';

export const isCacheObjectExpired = <T extends any>(item: SentinelCacheObject<T>) => {
  if (Date.now() > item.fetchedAt + 1000 * 60 * 60 * 24 * 3) return true; // 3 days
  return false;
};
